import { FC } from 'react';
import site from 'pro/config/site';

import {
    ContactAddress,
    ContactEmail,
    ContactPhone,
} from '@base/common/Contact';
import { Trans, useTrans } from 'base/utils/i18n';

type HelpLocationProps = {
    className?: string;
}

const HelpLocation: FC<HelpLocationProps> = ({ className }) => {
    const { t } = useTrans();
    return (
        <div className={className}>
            <p className="title"><strong>{t('web_contact_location_title')}</strong></p>
            <div className="body">
                <p><ContactAddress/></p>
                <p>
                    <ContactEmail/>
                    <br/>
                    <ContactPhone/>
                    <br/>
                    {site.contact.phone.onlineTime}
                </p>
                <p>
                    <Trans
                        i18nKey="web_contact_wholesale_email_text"
                        components={{ Email: <ContactEmail type={'wholesale'}/> }}
                    />
                </p>
                <p>
                    <Trans
                        i18nKey="web_contact_amazon_email_text"
                        components={{ Email: <ContactEmail type={'amazon'}/> }}
                    />
                </p>
            </div>
        </div>
    );
};

export default HelpLocation;